import { render, staticRenderFns } from "./simOpenSj.vue?vue&type=template&id=5054bfcd&scoped=true&"
import script from "./simOpenSj.vue?vue&type=script&lang=js&"
export * from "./simOpenSj.vue?vue&type=script&lang=js&"
import style0 from "./simOpenSj.vue?vue&type=style&index=0&id=5054bfcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054bfcd",
  null
  
)

export default component.exports